var exports = {
  "K": "GuildJoinMessage.module__icon___WFB5V1",
};

module.exports = exports;
